import { useSelector } from 'react-redux';

import GuestFileManager from 'components/Pages/Admin/Itineraries/Table/Confirmed/RowTabs/GuestInfoTable/GuestFileManager';
import i18n from 'i18n';
import { accountIdSelector } from 'store/user/selectors';
import { IGuestPortal } from 'utils/itineraryDetails/types';

import { useLandingV2Context } from '../../../../context';
import styles from './index.module.css';

function TravelWallet() {
  const { data: _data, readonly } = useLandingV2Context();
  const data = _data as IGuestPortal;
  const accId = useSelector(accountIdSelector);

  return (
    <div className={styles.container}>
      <GuestFileManager
        guestPortalId={data.id}
        archiveName={`${data.title} Files`}
        translate={readonly}
        getCreateArchiveEndpoint={() => `/acc/${accId}/guest_portals/${data.id}/documents/archive`}
        getPingEndpoint={(taskId: string) => `/acc/${accId}/guest_portals/${data.id}/documents/${taskId}/status`}
        getDownloadEndpoint={(taskId: string) => `/acc/${accId}/guest_portals/${data.id}/documents/${taskId}/download`}
        data={[
          {
            title: i18n.t('proposal_content.guest_portal.travel_wallet.sections.general_documents'),
            sections: [
              {
                title: i18n.t('proposal_content.guest_portal.travel_wallet.tabs.vouchers'),
                files: data.voucherDocuments,
              },
              {
                title: i18n.t('proposal_content.guest_portal.travel_wallet.tabs.e_tickets'),
                files: data.ticketDocuments,
              },
              {
                title: i18n.t('proposal_content.guest_portal.travel_wallet.tabs.waivers'),
                files: data.waiverDocuments,
              },
              {
                title: i18n.t('proposal_content.guest_portal.travel_wallet.tabs.misc'),
                files: data.miscDocuments,
              },
              {
                title: i18n.t('proposal_content.guest_portal.travel_wallet.tabs.links'),
                links: data.additionalLinks,
              },
            ],
          },
          {
            title: i18n.t('proposal_content.guest_portal.travel_wallet.sections.uploaded_via_guest_forms'),
            sections: [
              {
                title: i18n.t('proposal_content.guest_portal.travel_wallet.tabs.passports'),
                files: data.passportDocuments,
              },
              {
                title: i18n.t('proposal_content.guest_portal.travel_wallet.tabs.insurances'),
                files: data.insuranceDocuments,
              },
              {
                title: i18n.t('proposal_content.guest_portal.travel_wallet.tabs.guest_misc'),
                files: data.guestMiscDocuments,
              },
            ],
          },
        ]}
      />
    </div>
  );
}

export default TravelWallet;
